import { useEffect } from "react";

/**
 * Lightweight per-route SEO without extra deps: updates <title>, meta description,
 * canonical and og:url/og:title on mount. JS-executing crawlers (Google) pick these up.
 */
export function usePageMeta({ title, description, path = "/", noindex = false }) {
  useEffect(() => {
    const origin = "https://carspaclub.cz";
    const url = origin + path;

    if (title) document.title = title;

    const setMeta = (selector, attr, key, value) => {
      if (value == null) return;
      let el = document.head.querySelector(selector);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, key);
        document.head.appendChild(el);
      }
      el.setAttribute("content", value);
    };

    setMeta('meta[name="description"]', "name", "description", description);
    setMeta('meta[property="og:title"]', "property", "og:title", title);
    setMeta('meta[property="og:description"]', "property", "og:description", description);
    setMeta('meta[property="og:url"]', "property", "og:url", url);
    setMeta('meta[name="twitter:title"]', "name", "twitter:title", title);
    setMeta('meta[name="twitter:description"]', "name", "twitter:description", description);
    setMeta('meta[name="robots"]', "name", "robots", noindex ? "noindex, nofollow" : "index, follow, max-image-preview:large");

    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", url);
  }, [title, description, path, noindex]);
}
